import { render, staticRenderFns } from "./ScienceEvaluation.vue?vue&type=template&id=866e520a&scoped=true"
import script from "./ScienceEvaluation.vue?vue&type=script&lang=js"
export * from "./ScienceEvaluation.vue?vue&type=script&lang=js"
import style0 from "./ScienceEvaluation.vue?vue&type=style&index=0&id=866e520a&prod&scoped=true&lang=css"
import style1 from "./ScienceEvaluation.vue?vue&type=style&index=1&id=866e520a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "866e520a",
  null
  
)

export default component.exports